// extracted by css-extract-rspack-plugin
export default {"disabledRemind":"NoneOrRejectedButtons__disabledRemind--dPzS2"};